import React from 'react';
import 'twin.macro';
import { Infobox } from 'components/Callout/Infobox';
import SchoolyearButtonLink from 'components/Buttons/SchoolyearButtonLink';

interface Props {
  title: string;
  description: string;
  path: string;
  progName: string;
  ctaLink: string;
}

export function AlreadyAProgCallout(props: Props) {
  const { title, description, path, progName, ctaLink } = props;
  return (
    <div tw="text-lg mb-4">
      <Infobox intent="warning" tw="mb-8" title={title}>
        {description}
        <div tw="text-center mt-3">
          <SchoolyearButtonLink
            large
            intent="warning"
            outlined
            to={path}
            tw="inline-block font-semibold"
          >
            {ctaLink}
            <div tw="text-sm italic">({progName})</div>
          </SchoolyearButtonLink>
        </div>
      </Infobox>
    </div>
  );
}
